class CartPage extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", this.handleTextareaChange.bind(this));
  }

  handleTextareaChange(e) {
    const element = e.target;

    if (!element.hasAttribute("data-word-limit")) return;

    var parent = element.parentNode;

    if (!parent.querySelector(".notification")) {
      var notification = document.createElement("div");
      notification.classList.add("notification");
      notification.classList.add("fine");
      notification.innerText = "Maximum 25 words";
      parent.appendChild(notification);
    }

    var words = element.value.match(/\S+/g)
      ? element.value.match(/\S+/g).length
      : 0;

    if (words > 25) {
      var trimmed = element.value.split(/\s+/, 25).join(" ");
      element.value = trimmed;
      element.classList.add("over-limit");
    } else if (words < 20) {
      element.classList.remove("over-limit");
    }
  }
}
customElements.define("cart-page", CartPage);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      //cartItems.getCappAttribute(event);

      cartItems.updateQuantity(this.dataset.index, 0, "", event);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartWishlist extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      var wishlist = this.querySelector("#smartwishlist");

      var w_product_id = wishlist.dataset.product;
      var w_product_variant = wishlist.dataset.variant;
      // wishlist.click()

      if (typeof AddToSmartWishlist !== "undefined") {
        AddToSmartWishlist(w_product_id, w_product_variant);
      }
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-wishlist", CartWishlist);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]'),
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0,
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.checkAPO();

    this.addEventListener("change", this.debouncedOnChange.bind(this));

    this.image_observer;

    var lines_images = this.querySelectorAll(".cart-item__media img");

    Array.from(lines_images).forEach((image) =>
      this.addImageMutationObserver(image),
    );
  }

  checkAPO() {
    var aprod_variants = this.querySelectorAll(
      ".cart-item[data-aprod-variant]",
    );

    if (!aprod_variants[0]) return;

    //ensure base product exists
    Array.from(aprod_variants).forEach((aprod_variant, i) => {
      var hash = aprod_variant.dataset.aprodVariant;
      var base_product = this.querySelector(
        `[data-aprod-relation="${hash}"]:not([data-aprod-variant])`,
      );

      if (base_product) {
        //hide remove, add do not remove disclaimer
        aprod_variant.classList.add("aprod_variant");
        // //add order css variable to both products, ensure they are together
        // aprod_variant.style.setProperty("--order", i)
        // base_product.style.setProperty("--order", i)
        // DONT think this is needed as products are always added together
      } else {
        aprod_variant.classList.remove("aprod_variant");
      }
    });
  }

  getCappAttribute(event) {
    //check if capp prduct
    var capp_base = event.target.closest("[data-capp-base]");
    var attribute = false;

    if (capp_base) {
      //remove capp attribyre
      let timestamp = capp_base.dataset.cappBase;
      let attribute_key = `Custom Charm (${timestamp})`;

      attribute = {
        attributes: {
          [attribute_key]: null,
        },
      };
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(attribute),
      })
        .then((response) => response.json())
        .then((data) => console.log("Attribute removed:", data))
        .catch((error) => console.error("Error:", error));
    }
  }
  onChange(event) {
    //this.getCappAttribute(event);
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event,
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart__content",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".main-cart__content",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".main-cart__totals",
      },
      {
        id: "cart-wrapping",
        section: document.getElementById("cart-wrapping").dataset.id,
        selector: ".wrapping-items__container",
      },
    ];
  }

  updateQuantity(line, quantity, name, event) {
    this.enableLoading(line);

    const bodyData = {
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };

    const body = JSON.stringify(bodyData);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0,
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
      })
      .catch((e) => {
        console.error(e);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      })
      .finally(() => {
        this.getCappAttribute(event);
      });
  }

  renderContent(response) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector,
      );
    });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);

      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value,
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", false);
    }

    setTimeout(() => {
      if (cartStatus) {
        cartStatus.setAttribute("aria-hidden", true);
      }
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (!html) return;
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }

  addImageMutationObserver(image_el) {
    var initial_search = image_el.src;

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: false, subtree: false };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (
          mutation.attributeName == "src" &&
          mutation.target.src != initial_search
        ) {
          mutation.target.src = initial_search;
          // debugger
          //disconnect to prevent infinite loop
        }
      }
    };

    // Create an observer instance linked to the callback function
    this.image_observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    this.image_observer.observe(image_el, config);
  }
  disconnectedCallback() {
    this.image_observer.disconnect();
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300),
        );
      }
    },
  );
}
